export default {
  areAllRequiredFieldsFilledOut() {
    this.merchandiseOverlay.mutation0Error = false;
    if(!this.merchandiseOverlay.item.tempMutations[0].value) {
      this.merchandiseOverlay.mutation0Error = true;
      this.$swal(``, this.$t(`products-overview:line0Empty`), `warning`);
      return false;
    }
    return true;
  },
  closeMerchandiseOverlay(clearData = true) {
    if(clearData) {
      this.setTemporaryMerchandiseOverlayMutations();
    }

    this.merchandiseOverlay.item = null;
    this.merchandiseOverlay.visible = false;
    this.merchandiseOverlay.loading = false;
    this.merchandiseOverlay.mutation0Error = false;
  },
  async openMerchandiseOverlay(item) {
    this.merchandiseOverlay.isBusinessCard = await this.$productService.isBusinessCard(item);
    this.merchandiseOverlay.isCarDecal = await this.$productService.isCarDecal(item);
    this.merchandiseOverlay.visible = true;
    this.merchandiseOverlay.item = item;
    this.setTemporaryMerchandiseOverlayMutations();
  },
  setMerchandiseOverlayMutations() {
    for(const index of Object.keys(this.merchandiseOverlay.item.tempMutations)) {
      this.$set(this.merchandiseOverlay.item.mutations[index], `value`, this.merchandiseOverlay.item.tempMutations[index].value);
    }
  },
  setTemporaryMerchandiseOverlayMutations() {
    if(!this.merchandiseOverlay.item) {
      return;
    }
    this.$set(this.merchandiseOverlay.item, `tempMutations`, []);
    for(const index of Object.keys(this.merchandiseOverlay.item.mutations)) {
      this.$set(this.merchandiseOverlay.item.tempMutations, index, { id: index, value: this.merchandiseOverlay.item.mutations[+index].value });
    }
  },
};
